<template>
    <div class="ReportList" style="background: #EEEEEE;" >
<!--      :style="{ background: ( list.length != 0 ? '#EEEEEE' : '#FFFFFF' ) }"-->
<!--      <div class="header">-->
<!--        <img src="../../assets/report/banner.png" alt="">-->
<!--      </div>-->
      <mu-tabs :value.sync="json_list.reportType"
               @change="tabChange"
               class="tab"
               inverse
               color="#3B9CFD"
               indicator-color="#3B9CFD"
               full-width
               center>
        <mu-tab :value="''" >全部</mu-tab>
        <mu-tab v-for="item in $store.state.report_type" :key="item.dictKey" :value="item.dictKey" >{{ item.dictValue }}</mu-tab>
      </mu-tabs>


      <template v-if="list.length != 0">

        <ul class="list">
          <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
            <li :class="( !item.readed ? 'new' : '' )"  v-for="item in list" :key="item.id" @click="link_deta(item)" >
              <div class="background exabackground" v-if="item.reportType == 0" >
                <p>体检报告</p>
                <img src="../../assets/report/exa.png" alt="">
              </div>

              <div class="background gastroscopebackground" v-if="item.reportType == 1" >
                <p>胃镜报告</p>
                <img src="../../assets/report/gastroscope.png" alt="">
              </div>

              <div class="background colonoscopybackground" v-if="item.reportType == 2" >
                <p>肠镜报告</p>
                <img src="../../assets/report/Colonoscopy.png" alt="">
              </div>

              <div class="background followbackground" v-if="item.reportType == 3" >
                <p>复诊报告</p>
                <img src="../../assets/report/Follow.png" alt="">
              </div>

              <div class="list_item">
                <div class="list_item_title">
                  <span>
                    <p>{{ item.name }}</p>
                    <p v-if="item.gender == 0">女</p>
                    <p v-if="item.gender == 1">男</p>
                    <p>{{ item.phoneNo }}</p>
                  </span>
                  <span>
                    {{ item.diagnoseTime }}
                  </span>
                </div>
                <h2>{{ item.hospitalName }}</h2>
              </div>

            </li>
          </mu-load-more>
        </ul>

      </template>


      <template v-else>
        <NoList>
          <template #text>
            <div class="noList_text">
              <p>您还没有报告</p>
              <div class="color">
                可以使用<span @click="link('/LookupReport')" >查找报告</span>进行查询
              </div>
            </div>
          </template>
        </NoList>
      </template>

    </div>
</template>

<script>
export default {
  name: "ReportList",
  data() {
    return{
      list: [],
      json_list: {
        pageNum: 1,
        pageSize: 10,
        reportType: '',
        name: null,
        orderId: null,
        phoneNo: null,
        queryType: "query"
      },
      loadall: false,
      loading: false,
    }
  },
  created() {

    this.$isIos();

    this.$store.dispatch("setReportType");

    if(this.$route.query.data) {
      console.log(11)
      let data= JSON.parse(this.$route.query.data);
      this.json_list.name= data.name;
      this.json_list.phoneNo= data.phoneNo;
      this.json_list.queryType= "query";
      this.get_list(this.json_list);
    }

    console.log(this.$route.query)


    if(this.$route.query.orderNum) {
      this.json_list.orderNo= this.$route.query.orderNum;
      this.json_list.queryType= "query";
      this.get_list(this.json_list);
    }


  },
  mounted() {

  },
  methods: {
    link_deta(e) {
      this.$router.push({
        path: "/ReportDeta",
        query: {
          id: e.id
        }
      })
    },
    get_list(y) {
      this.$get("report/page",y)
          .then(res => {
            if(res) {
              console.log(res)
              this.loadall= !res.data.hasNextPage;
              this.loading= false;

              res.data.list.forEach((item)=> {
                this.list.push(item);
              })

            }
          })
    },
    load() {
      console.log("loading")
      this.json_list.pageNum= this.json_list.pageNum + 1;
      this.get_list(this.json_list);
    },
    tabChange(e) {
      console.log(e)
      this.list= [];
      this.json_list.pageNum= 1;
      this.get_list(this.json_list);
    },
    link(e) {
      this.$router.push({
        path: e
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../style/Report/ReportList";
</style>
